import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Push bildirimleri için service worker kaydı — sekme kapalı/arka planda olsa bile bildirim
// gösterebilmenin ön koşulu. Yalnızca destekleyen tarayıcılarda (Chrome/Android) çalışır.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch(() => {});
  });
}
